module.exports = __webpack_public_path__ + "static/scape-formation-iii_acrylic-on-canvas-105x105in-2016-9c293eae998cc9e545918f8553cb8283.jpg";